var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.expenses.length
        ? _c(
            "div",
            { staticClass: "flex flex_gap_10 mb-2" },
            _vm._l(_vm.getSummaryExpenses(), function (exp, e) {
              return _c("div", { staticClass: "border p-1" }, [
                _vm._v(_vm._s(exp.currency_title) + ": "),
                _c("strong", [_vm._v(_vm._s(exp.sum))]),
                _vm._v(" (" + _vm._s(exp.count) + ")\n    "),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.editExpenses, function (exp, i) {
        return _c("div", { key: exp.id, staticClass: "row block" }, [
          _c(
            "div",
            { staticClass: "p-0 col-md-5 flex" },
            [
              _vm.$currentRole !== "admin" && _vm.expensesUsers
                ? [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: exp.user_id,
                            expression: "exp.user_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              exp,
                              "user_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._l(_vm.expensesUsers, function (u) {
                          return _c("option", { domProps: { value: u.id } }, [
                            _vm._v(_vm._s(u.name)),
                          ])
                        }),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v("Администрация"),
                        ]),
                      ],
                      2
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "created_info" },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              exp.to_division_id
                                ? _vm.mixinGetDivisionName(
                                    _vm.$AllDivisions[exp.to_division_id]
                                  )
                                : "Администрация"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.users && _vm.users[exp.user_id]
                          ? [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.users && _vm.users[exp.user_id]) ||
                                      exp.user_id ||
                                      "Админ"
                                  )
                                ),
                              ]),
                            ]
                          : [
                              _c(
                                "p",
                                [
                                  _c("UserName", {
                                    attrs: { id: exp.user_id },
                                  }),
                                ],
                                1
                              ),
                            ],
                        _vm._v(" "),
                        _c("p", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(
                              exp.created_at
                                ? _vm.printDate(exp.created_at)
                                : "новый расход"
                            )
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
              _vm._v(" "),
              (_vm.chiefRunners ?? []).length > 1
                ? _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: exp.user_id,
                          expression: "exp.user_id",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            exp,
                            "user_id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v("Выберите пользователя")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.chiefRunners, function (u) {
                        return _c("option", { domProps: { value: u.id } }, [
                          _vm._v(_vm._s(u.name)),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: exp.type_id,
                      expression: "exp.type_id",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: exp.to_delete || exp.disabled },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        exp,
                        "type_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0", disabled: "" } }, [
                    _vm._v("Выберите тип расхода"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.allTypes, function (type, id) {
                    return (exp.id &&
                      exp.user_id === _vm.$currentUID &&
                      _vm.allowExpensesTypes.includes(+id)) ||
                      (exp.id && exp.user_id !== _vm.$currentUID) ||
                      _vm.$currentRole === "admin" ||
                      _vm.allowExpensesTypes.includes(+id)
                      ? _c("option", { domProps: { value: id } }, [
                          _vm._v("\n          " + _vm._s(type) + "\n        "),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
              _vm._v(" "),
              false && !+_vm.division
                ? _c("input", {
                    staticClass: "w_120 form-control",
                    attrs: { type: "text", disabled: "" },
                    domProps: { value: exp.affect_saldo ? "" : "н/в прибыль" },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "p-0 col-md-4" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: exp.comment,
                  expression: "exp.comment",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                disabled: exp.to_delete || exp.disabled,
                placeholder: "Комментарий",
              },
              domProps: { value: exp.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(exp, "comment", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-0 col-md-3" }, [
            _c("div", { staticClass: "flex" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: exp.sum,
                    expression: "exp.sum",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  disabled: exp.to_delete || exp.disabled,
                  placeholder: "Сумма",
                },
                domProps: { value: exp.sum },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(exp, "sum", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: exp.currency_id,
                      expression: "exp.currency_id",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: exp.to_delete || exp.disabled },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        exp,
                        "currency_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0", disabled: "" } }, [
                    _vm._v("Выберите валюту"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.$AllCurrencies, function (curr) {
                    return exp.id ||
                      _vm.$currentRole === "admin" ||
                      _vm.allowCurrencies.includes(+curr.id)
                      ? _c("option", { domProps: { value: curr.id } }, [
                          _vm._v(_vm._s(curr.currency) + "\n          "),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
              _vm._v(" "),
              !exp.disabled
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function ($event) {
                          exp.to_delete = !exp.to_delete
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          false && !exp.id
            ? _c("div", { staticClass: "flex" }, [
                _c(
                  "label",
                  { staticClass: "w_300", attrs: { for: "check_1_a" } },
                  [
                    _c("input", {
                      staticClass: "from-control pointer",
                      attrs: { type: "checkbox", id: "check_1_a" },
                      on: { change: (e) => _vm.updateType(e, i) },
                    }),
                    _vm._v("\n        сделать регулярным\n      "),
                  ]
                ),
                _vm._v(" "),
                exp.pass_type === 2
                  ? _c("div", { staticClass: "input-group" }, [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: exp.extra_data.period,
                            expression: "exp.extra_data.period",
                          },
                        ],
                        staticClass: "form-control w_110",
                        attrs: { type: "number" },
                        domProps: { value: exp.extra_data.period },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              exp.extra_data,
                              "period",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: exp.extra_data.period_type,
                                expression: "exp.extra_data.period_type",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  exp.extra_data,
                                  "period_type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { attrs: { value: "days" } }, [
                              _vm._v("дней"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "month" } }, [
                              _vm._v("месяцев"),
                            ]),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-content-between p-t-10" },
        [
          _c(
            "button",
            { staticClass: "btn btn-info", on: { click: _vm.addNew } },
            [_vm._v("Добавить расход")]
          ),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-success",
                "data-style": "zoom-in",
                loading: _vm.loading,
              },
              on: { click: _vm.save },
            },
            [_vm._v("Сохранить расходы\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _vm._v("повторять каждые"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }